/*
 * @Description: 嘉宾管理API
 * @Author: AI Assistant
 * @Date: 2023-10-30
 */

import request from '@/utils/request'

/**
 * 获取嘉宾列表
 */
export const getGuestList = async data => request({ url: '/guest/list', method: 'GET', params: data })

/**
 * 获取嘉宾完整信息（包含日程和议程）
 */
export const getGuestListWithSchedules = async data => request({ url: '/guest/listWithSchedules', method: 'GET', params: data })

/**
 * 获取嘉宾详情
 */
export const getGuestDetail = async id => request({ url: '/guest/detail', method: 'POST', data: { id } })

/**
 * 新增嘉宾
 */
export const addGuest = async data => request({ url: '/guest/add', method: 'POST', data })

/**
 * 编辑嘉宾
 */
export const editGuest = async data => request({ url: '/guest/edit', method: 'POST', data })

/**
 * 删除嘉宾
 */
export const deleteGuest = async id => request({ url: '/guest/delete', method: 'POST', data: { id } })

/**
 * 批量删除嘉宾
 */
export const batchDeleteGuests = async ids => request({ url: '/guest/batchDelete', method: 'POST', data: { ids } })

/**
 * 更新嘉宾排序
 */
export const updateGuestSort = async guestsSort => request({ url: '/guest/updateSort', method: 'POST', data: { guestsSort } })

/**
 * 获取嘉宾分类列表
 */
export const getGuestCategories = async () => request({ url: '/guest/categories', method: 'GET' })

/**
 * 添加嘉宾分类
 */
export const addGuestCategory = async data => request({ url: '/guest/category/add', method: 'POST', data })

/**
 * 编辑嘉宾分类
 */
export const editGuestCategory = async data => request({ url: '/guest/category/edit', method: 'POST', data })

/**
 * 删除嘉宾分类
 */
export const deleteGuestCategory = async data => request({ url: '/guest/category/delete', method: 'POST', data })

// 导出嘉宾数据
export function exportGuests(data) {
  return request({
    url: '/guest/export',
    method: 'post',
    data
  });
}

// 获取导入模板
export function getImportTemplate() {
  return request({
    url: '/guest/import/template',
    method: 'get'
  });
}

// 验证导入数据
export function validateImportData(data) {
  return request({
    url: '/guest/import/validate',
    method: 'post',
    data
  });
}

// 处理导入数据
export function processImportData(data) {
  return request({
    url: '/guest/import/process',
    method: 'post',
    data
  });
}

// 导入嘉宾数据
// 注意：批量导入需上传头像ZIP并逐条写库，耗时远超全局 15s 超时，
// 这里单独放开超时（10 分钟），避免前端提前中断导致「已导入但报失败」
export function importGuests(formData) {
  return request({
    url: '/guest/import/process',
    method: 'post',
    data: formData,
    timeout: 600000,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
} 